/** 4.27 Link: small-b accent, underline on hover/focus. A router link or a button. */
import type { MouseEvent, ReactElement, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
export function TextLink({ to, onClick, children, secondary = false, className = "" }: { to?: string; onClick?: (e: MouseEvent<HTMLElement>) => void; children: ReactNode; secondary?: boolean; className?: string }): ReactElement {
  const cls = `link ${secondary ? "link--secondary" : ""} ${className}`;
  if (to) return <RouterLink to={to} className={cls} onClick={onClick as (e: MouseEvent<HTMLAnchorElement>) => void}>{children}</RouterLink>;
  return <button type="button" className={cls} onClick={onClick}>{children}</button>;
}
